<svelte:component this={Entry} />

<Loading />

<svelte:head>
  {#if showIcons}
    <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">
  {/if}
</svelte:head>

<script>
  import { setContext } from 'svelte'
  import Loading from '@/components/Loading'

  export let Entry

  // We expect the client and server entry points to pass in an object that contains all shared platform data
  export let platform

  // We set the platform on the context here since this component is the parent of all other components
  // This way any child component can access the platform object when it needs to
  setContext('platform', platform)

  const { store } = platform
  let showIcons = false

  $: if ($store.auth.claims || ($store.icons && $store.icons.material)) {
    showIcons = platform.api.core.isLoggedIn() || ($store.icons && $store.icons.material)
  }

  platform.router.before(async ({ pathname }) => {
    if (!pathname.startsWith('/cms/')) {
      try {
        const urlMaps = await platform.api.cms.urlMaps.findAllPages({ extract: true })

        for (const urlMap of urlMaps) {
          if (urlMap.useSourceRegex) {
            const r = new RegExp(urlMap.source)

            if (r.test(pathname)) {
              return { redirect: urlMap.destination }
            }
          } else if (urlMap.source === pathname) {
            return { redirect: urlMap.destination }
          }
        }
      } catch (err) {}
    }

    return await platform.api.core.render.isAccessible(pathname)
  })

  platform.router.after(async ({ pathname }) => {
    await platform.api.core.render.load(pathname)
    Entry = await platform.api.core.selectEntry(platform.storeData.config.site.routes)
  })
</script>

<noscript>
  <style>
    :global([data-animation-names]) {
      opacity: 1!important;
    }
  
</style>
</noscript>

<style lang="scss">:global(html),
:global(body) {
  margin: 0;
  padding: 0;
  font: 14px sans-serif;
  line-height: normal;
  background: #fff;
  color: #333;
}
:global(html) {
  box-sizing: border-box;
  overflow-x: hidden;
  scroll-behavior: smooth;
}
:global(*),
:global(*:before),
:global(*:after) {
  box-sizing: inherit;
}
:global(img) {
  border: none;
  max-width: 100%;
  height: auto;
}
:global(table) {
  border-spacing: 0;
  position: relative;
}
:global(.cms-disable-scroll) {
  -webkit-overflow-scrolling: touch;
  overflow: hidden;
}
:global(.error-text) {
  color: red;
}</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>